import { ArrowDown } from "react-feather";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Label, Progress } from "reactstrap";
import "./toast.scss";

const Rush = () => {
  const { t } = useTranslation();
  const RushsReducer = useSelector((state) => state.rushReducer);

  return (
    <div className="TuneIn">
      {RushsReducer.upload_success !== -1 && (
        <div className="toast-container">
          <div className="d-flex align-items-center">
            <Label for="sort-select" className="me-2">
              <ArrowDown color="#4caa4c" />
            </Label>
            <Label for="sort-select">
              {RushsReducer.upload_success}% {t("uploaded...")}
            </Label>
          </div>
          <Progress
            id="progressBarUploadToast"
            animated
            color="success"
            value={RushsReducer.upload_success}
            max={100}
          />
        </div>
      )}
    </div>
  );
};

export default Rush;
